import React, { useState } from "react";
import { FaUser, FaLock, FaArrowRight, FaShieldAlt } from "react-icons/fa";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Login functionality (demo)");
  };

  return (
    <div className="relative min-h-screen overflow-hidden bg-gradient-to-br from-[#eafaff] via-white to-[#dff7fb]">
      <div className="absolute top-16 left-8 w-72 h-72 bg-[#1298b5]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-16 right-8 w-80 h-80 bg-[#f97316]/10 rounded-full blur-3xl"></div>

      <div className="relative max-w-md mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white/95 backdrop-blur-sm rounded-3xl shadow-2xl p-8 border border-[#d8f4f8]">
          <div className="text-center mb-7">
            <div className="w-16 h-16 mx-auto bg-gradient-to-br from-[#1298b5] to-[#0b819b] text-white rounded-2xl flex items-center justify-center text-2xl shadow-lg mb-4">
              <FaShieldAlt />
            </div>

            <h2 className="text-3xl font-extrabold text-[#073b4c] mb-2">
              Welcome Back
            </h2>

            <p className="text-gray-500">Login to your account</p>

            <div className="h-1 w-16 bg-gradient-to-r from-[#1298b5] to-[#f97316] mx-auto rounded mt-5"></div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-semibold text-[#073b4c] mb-1">
                Email
              </label>

              <div className="relative">
                <FaUser className="absolute left-3 top-1/2 -translate-y-1/2 text-[#1298b5]" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-10 pr-3 py-3 border border-[#d8f4f8] rounded-xl focus:ring-2 focus:ring-[#1298b5]/30 focus:border-[#1298b5] outline-none"
                  placeholder="you@example.com"
                  required
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-semibold text-[#073b4c] mb-1">
                Password
              </label>

              <div className="relative">
                <FaLock className="absolute left-3 top-1/2 -translate-y-1/2 text-[#1298b5]" />
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full pl-10 pr-3 py-3 border border-[#d8f4f8] rounded-xl focus:ring-2 focus:ring-[#1298b5]/30 focus:border-[#1298b5] outline-none"
                  placeholder="••••••••"
                  required
                />
              </div>
            </div>

            <div className="flex items-center justify-between text-sm">
              <label className="flex items-center gap-2 text-gray-600">
                <input type="checkbox" className="rounded accent-[#1298b5]" />
                Remember me
              </label>

              <a href="#" className="text-[#1298b5] hover:text-[#f97316] hover:underline">
                Forgot password?
              </a>
            </div>

            <button
              type="submit"
              className="w-full bg-gradient-to-r from-[#1298b5] to-[#0b819b] hover:from-[#f97316] hover:to-[#fb923c] text-white py-3 rounded-xl font-bold transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
            >
              Sign In <FaArrowRight />
            </button>
          </form>

          <p className="text-center text-sm text-gray-500 mt-6">
            Don't have an account?{" "}
            <a href="#" className="text-[#1298b5] hover:text-[#f97316] hover:underline font-semibold">
              Register
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;